module.exports = __webpack_public_path__ + "media/audio1.33df9888.mp3";